
export default function mainSearchExecute (mobileSearch = false) {
  const searchTerm = mobileSearch ? $('.mobile-search .main-search').val() : $('.main-search').val()
  const url = new URL(document.location)
  const params = new URLSearchParams(url.search.slice(1))
  params.set('search', searchTerm)
  document.location = '/items?' + params.toString()
}
